<template>
    <div>
        <v-row no-gutters align="center">
            <v-col cols="12" md="6">
                <modal-cadu :close="true" @input="$emit('input', false)" :width="width" :value="value">
                    <div slot="all" class="py-10 px-10">
                        <div slot="body">
                            <v-row v-if="!$vuetify.breakpoint.xs" class="align-center justify-center ">
                                <v-col cols="auto" class="mb-6">
                                    <div class="font-secundaria font-weight-bold headline fontColor--text" v-if="tipo && !title">
                                        Tem certeza que deseja salvar a alteração?
                                    </div>
                                    <div class="font-secundaria font-weight-bold headline fontColor--text" v-else-if="!title && !tipo">
                                        Deseja realmente voltar?
                                    </div>
                                    <div class="font-secundaria font-weight-bold headline fontColor--text" v-else-if="title">
                                       {{title}}
                                    </div>
                                </v-col>
                                <v-row class="align-center justify-space-around">
                                    <v-col cols="auto">
                                        <button-cadu
                                            :text="this.tipo ? 'CANCELAR' : 'NÃO'"
                                            @click="$emit('input', false)"
                                            outline
                                        />
                                    </v-col>
                                    <v-col cols="auto">
                                        <button-cadu
                                            text="SIM"
                                            @click="$emit('salvarVersao')"
                                            :backColor="$vuetify.theme.themes.light.primary1"
                                        />
                                    </v-col>
                                </v-row>
                            </v-row>
                            <v-row v-else class="align-center justify-center">
                                <v-col cols="12" class="mb-6">
                                    <div class="font-secundaria font-weight-bold headline fontColor--text" v-if="tipo && !title">
                                        Tem certeza que deseja salvar a alteração?
                                    </div>
                                    <div class="font-secundaria font-weight-bold headline fontColor--text" v-else-if="!title && !tipo">
                                        Deseja realmente voltar?
                                    </div>
                                    <div class="font-secundaria font-weight-bold headline fontColor--text" v-else-if="title">
                                       {{title}}
                                    </div>
                                </v-col>
                                <v-col cols="auto">
                                    <button-cadu
                                        text="SIM"
                                        @click="$emit('salvarVersao')"
                                        :backColor="$vuetify.theme.themes.light.primary1"
                                    />
                                </v-col>
                                <v-col cols="auto">
                                    <button-cadu
                                        :text="this.tipo ? 'CANCELAR' : 'NÃO'"
                                        @click="$emit('input', false)"
                                        outline
                                        v-if="tipo"
                                    />
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </modal-cadu>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    tipo: {
      type: Boolean,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    width: {
      type: Number,
      required: false,
      default: 620
    }
  },
  data () {
    return {
      valueData: this.value,
      iconStyle: {
        color: this.$vuetify.theme.themes.light.primary1
      }
    }
  }
}
</script>
